const getters = {
    unReadMsgNum: state => state.app.unReadMsgNum,
    badgeHidden: state => state.app.badgeHidden
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js